// src/pages/nascar/CupOdds.jsx
import React from "react";
import NascarBetting from "./NascarBetting";

export default function CupBettingPage() {
  return <NascarBetting series="cup" />;
}
